import Vue from 'vue'
import Vuex from 'vuex'

import authentication from './modules/authentication'
import category from './modules/category'
import brand from './modules/brand'
import product from './modules/product'
import shoppingcart from './modules/shoppingcart'
import order from './modules/order'
import customer from './modules/customer'
import discount from './modules/discount'
import document from './modules/document'
import image from './modules/image'
import mail from './modules/mail'
import action from './modules/action'
import prices from './modules/prices'
import job from './modules/job'
import bulkprice from './modules/bulkprice'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        authentication,
        category,
        brand,
        product,
        shoppingcart,
        order,
        customer,
        discount,
        document,
        image,
        mail,
        action,
        prices,
        job,
        bulkprice
    }
})
